export default __webpack_public_path__ + "static/media/HR.434291d3.svg";